import { forwardRef, type SelectHTMLAttributes } from "react";
import { Icon } from "@/lib/Icon";
import { cn } from "@/lib/cn";

/** Compact plan selector shared by medication plans and lab delivery frequency. */
export const PlanSelect = forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      {...props}
      className={cn(
        "w-full appearance-none border border-line-subtle bg-sunken pl-10 pr-30 py-8 type-label-sm text-ink-secondary disabled:opacity-60",
        className,
      )}
    >
      {children}
    </select>
    <span
      aria-hidden
      className="pointer-events-none absolute right-10 top-1/2 -translate-y-1/2 inline-flex items-center justify-center text-ink"
    >
      <Icon name="Arrow" viewBox="0 0 10 12" className="w-[.6rem] rotate-90" />
    </span>
  </div>
));
PlanSelect.displayName = "PlanSelect";
